import React, { useState, useContext, useEffect } from "react";
import { LoadingSpinner } from "../utils/LoadingSpinner";
import { Link, Redirect} from "react-router-dom";
import { AccountContext } from "../User/Account";
import Modal from "../utils/Modal/Modal";
import VerifyUser from "./ItemModal/VerifyUser";
import ForgotPassword from "./ItemModal/ForgotPassword";

export const Login = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [errorLogin, setErrorLogin] = useState("")
	const [modalOpen, setModalOpen] = useState(false);
	const [currentModalComponent, setCurrentModalComponent] = useState(<div></div>)

	const { Auth } = useContext(AccountContext);

	const {isAuthenticated, getSession} = useContext(AccountContext);

	useEffect(() => {
        getSession().then((session: any) => {
            console.log("Session: ", session);
        }).catch((err: any) => {console.error("Failed to get session", err)})
    }, [])


	let VerifyUserComponent = <VerifyUser username={username} password={password}></VerifyUser>
	let ForgotPasswordComponent = <ForgotPassword></ForgotPassword>

	useEffect(() => {
		VerifyUserComponent = <VerifyUser username={username} password={password}></VerifyUser>
		ForgotPasswordComponent = <ForgotPassword></ForgotPassword>
	}, [username, password])
	
	const onLogInClick = async (e: React.FormEvent<EventTarget>) => {
		e.preventDefault();
		setIsLoading(true);

		Auth(username, password)
			.then((data: any) => {
				console.log("Logged In!", data)
				setIsLoading(false)
			}
			).catch((err: any) => {
				console.error("Failed to Login", err);
				if (err.message === "User is not confirmed.") {
					setCurrentModalComponent(VerifyUserComponent);
					setModalOpen(true)
				}
				setErrorLogin(err.message)
				setIsLoading(false)
			});
	};

	const forgotPasswordPopUp = () => {
		setCurrentModalComponent(ForgotPasswordComponent);
		setModalOpen(true)
	}

	if (isLoading) {
		return <LoadingSpinner></LoadingSpinner>;
	}

	const forgotPasswordBody = (
		<div className="col-md-2">
			<button className="d-lg-flex justify-content-center align-items-center btn btn-danger mb-2" onClick={forgotPasswordPopUp}>
				Forgot My Password
			</button>
		</div>
	);

	return (
		<div className="container my-5">
			
			<div className='btn btn-danger' style={{width: "100%", visibility: errorLogin !== "" ? 'visible': 'hidden'}}>{errorLogin}</div>
			<form>
				<div className="form-group mt-3">
					<label htmlFor="exampleInputEmail1">Username</label>
					<input
						onChange={(e) => setUsername(e.target.value)}
						type="text"
						className="form-control mb-3"
						id="exampleInputEmail1"
						aria-describedby="emailHelp"
						placeholder="Enter Username"
					/>
				</div>

				<div className="form-group">
					<label htmlFor="exampleInputPassword1">Password</label>
					<input
						onChange={(e) => setPassword(e.target.value)}
						type="password"
						className="form-control mb-3"
						id="exampleInputPassword1"
						placeholder="Enter Password"
					/>
				</div>
				<div className="row g-0">
					<div className="col-md-7">
						{/* Desktop Image */}
						<button
							disabled={!username || !password}
							onClick={onLogInClick}
							className="d-lg-flex btn btn-danger"
						>
							Log In
						</button>
					</div>
				</div>
			</form>

			<div className="">
				<div>
					<hr />

					{forgotPasswordBody}

					<div className="col-md-3">
						<button className="d-lg-flex justify-content-center align-items-center btn btn-danger mb-5">
							<Link to="/signup" className="text-white">
								Don't have an account? Sign Up
							</Link>
						</button>
					</div>
				</div>
			</div>
			{isAuthenticated ? <Redirect to="/"></Redirect> : null}
			{modalOpen ? <Modal setOpenModal={setModalOpen} component={currentModalComponent} /> : null}
		</div>
	);
};
